<div class="container">
    <div [class]="'header ' + headerClass">{{header}}</div>
    <ng-content></ng-content>
</div>
